<template>
    <div>
        <v-row class="">
             <!-- COLUMN 1 ///////////////////////////////////////// -->
            <v-col cols="4" md="4" sm="4" class="ml-0 pl-0">
                <div class="d-block mt-6 justify-start info--text label_medium">
                    <v-text-field
                        v-model="moduleDetails.module_name"
                        label="Module Name"
                        color="primary darken-1"
                        @change="debounceDelay({module_id: moduleDetails.module_id, module_name: moduleDetails.module_name})">
                    </v-text-field>
                </div>

                <div class="d-block mt-6 justify-start info--text label_medium">
                    <v-text-field
                        v-model="moduleDetails.steps_to_complete"
                        label="Roadmap Steps To Complete"
                        color="primary darken-1"
                        @change="debounceDelay({module_id: moduleDetails.module_id, steps_to_complete: moduleDetails.steps_to_complete})">
                    </v-text-field>
                </div>

                <div class="d-block mt-6 justify-start info--text label_medium">
                    <v-text-field
                        v-model="moduleDetails.calls_allowed"
                        label="Calls Allowed"
                        color="primary darken-1"
                        @change="debounceDelay({module_id: moduleDetails.module_id, calls_allowed: moduleDetails.calls_allowed})">
                    </v-text-field>
                </div>

                <div class="d-block mt-6 justify-start info--text label_medium">
                    <v-text-field
                        v-model="moduleDetails.revision_rounds"
                        label="Revision Rounds"
                        color="primary darken-1"
                        @change="debounceDelay({module_id: moduleDetails.module_id, revision_rounds: moduleDetails.revision_rounds})">
                    </v-text-field>
                </div>

                <div class="d-block mt-6 justify-start info--text label_medium">
                    <v-text-field
                        v-model="moduleDetails.days_to_complete"
                        label="Days To Complete"
                        color="primary darken-1"
                        @change="debounceDelay({module_id: moduleDetails.module_id, days_to_complete: moduleDetails.days_to_complete})">
                    </v-text-field>
                </div>
            </v-col>

            <!-- COLUMN 2 ///////////////////////////////////////// -->
            <v-col cols="5" md="5" sm="5" class="pa-2 pl-12">
                <div class="d-block mt-6 justify-start info--text label_medium">
                    <v-text-field
                        v-model="moduleDetails.srg_team.teamcal"
                        label="Calendly Url"
                        color="primary darken-1">
                    </v-text-field>
                    <div class="d-block d-flex justify-end">
                        <v-btn 
                            color="primary" 
                            class="d-flex d-block justify-end ml-1 mt-n3 mb-1"
                            auto-grow
                            outlined
                            x-small
                            @click="debounceDelay({ module_id: moduleDetails.module_id, teamcal: moduleDetails.srg_team })">
                            save url
                        </v-btn>
                    </div>
                </div>

                <div class="d-block mt-6 justify-start info--text label_medium">
                    <v-text-field
                        v-model="moduleDetails.srg_team.teamemail"
                        label="Module Email"
                        color="primary darken-1">
                    </v-text-field>
                    <div class="d-block d-flex justify-end">
                        <v-btn 
                            color="primary" 
                            class="d-flex d-block justify-end ml-1 mt-n3 mb-1"
                            auto-grow
                            outlined
                            x-small
                            @click="debounceDelay({module_id: moduleDetails.module_id, teamemail: moduleDetails.srg_team})">
                            save email
                        </v-btn>
                    </div>
                </div>

                <div class="d-block mt-6 justify-start info--text label_medium">
                    <v-textarea
                        v-model="formattedModuleDescription"
                        label="Module Description"
                        outlined
                        rows="6">
                    </v-textarea>
                    <div class="d-block d-flex justify-end">
                        <v-btn 
                            color="primary" 
                            class="d-flex d-block justify-end ml-1 mt-n3 mb-1"
                            auto-grow
                            outlined
                            x-small
                            @click="debounceDelay({module_id: moduleDetails.module_id, module_description: moduleDetails.module_description})">
                            save description
                        </v-btn>
                    </div>
                </div>
            </v-col>

            <!-- COLUMN 3 ///////////////////////////////////////// -->
            <v-col cols="3" md="3" sm="3" class="">
                <div class="d-block d-flex justify-end info--text label_medium">
                    <div class="d-inline align-self-center">Is Active:</div>
                    <div class="d-inline ml-6 justify-end align-self-center">
                        <v-switch
                            v-model="moduleDetails.is_active"
                            :label="`${moduleDetails.is_active ? 'Yes' : 'No'}`"
                            @change="debounceDelay({module_id: moduleDetails.module_id, is_active: moduleDetails.is_active})">
                        </v-switch>
                    </div>
                </div>

                <div class="d-block d-flex justify-end info--text label_medium">
                    <div class="d-inline align-self-center">Independent Uploads Default:</div>
                    <div class="d-inline ml-6 justify-end align-self-center">
                        <v-switch
                            v-model="moduleDetails.independent_uploads_default"
                            :label="`${moduleDetails.independent_uploads_default ? 'On' : 'Off'}`"
                            @change="debounceDelay({module_id: moduleDetails.module_id, independent_uploads_default: moduleDetails.independent_uploads_default})">
                        </v-switch>
                    </div>
                </div>

                <div v-if="moduleDetails.can_annualize" class="d-block d-flex justify-end info--text label_medium">
                    <div class="d-inline align-self-center">Annualize Default:</div>
                    <div class="d-inline ml-6 justify-end align-self-center">
                        <v-switch
                            v-model="moduleDetails.annualize_default"
                            :label="`${moduleDetails.annualize_default ? 'On' : 'Off'}`"
                            @change="annualizeDefaultChanged">
                        </v-switch>
                    </div>
                </div>

                <div class="expedite_block ml-auto" :class="moduleDetails.can_expedite ? 'bordered_block px-2' : ''" >
                    <div class="d-block d-flex justify-end info--text label_medium">
                        <div class="d-inline align-self-center">Can Grant Priority Access:</div>
                        <div class="d-inline ml-6 justify-end align-self-center">
                            <v-switch
                                v-model="moduleDetails.can_expedite"
                                :label="`${moduleDetails.can_expedite ? 'Yes' : 'No'}`"
                                @change="debounceDelay({module_id: moduleDetails.module_id, can_expedite: moduleDetails.can_expedite})">
                            </v-switch>
                        </div>
                    </div>

                    <div v-if="moduleDetails.can_expedite" class="expedite_field d-block mt-6 justify-start info--text label_medium">
                        <v-text-field
                            v-model="moduleDetails.expedited_cost"
                            label="Expedited Cost"
                            prepend-icon="mdi-currency-usd"
                            color="primary darken-1"
                            @change="debounceDelay({module_id: moduleDetails.module_id, expedited_cost: moduleDetails.expedited_cost})">
                        </v-text-field>
                    </div>

                    <div v-if="moduleDetails.can_expedite" class="expedite_field d-block mt-6 justify-start info--text label_medium">
                        <v-text-field
                            v-model="moduleDetails.expedited_days_to_complete"
                            label="Expedited Days To Complete"
                            color="primary darken-1"
                            @change="debounceDelay({module_id: moduleDetails.module_id, expedited_days_to_complete: moduleDetails.expedited_days_to_complete})">
                        </v-text-field>
                    </div>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>  
    import { toDollars } from './utilities'

    export default {
        name: 'ModuleData',

        props: {
            moduleDetails: Object,
            saveModuleData: Function,
        },
        
        computed: {
            formattedModuleDescription: {
                get() {
                    return this.moduleDetails.module_description;
                },
                set(value) {
                    this.moduleDetails.module_description = value;
                }
            }
        },

        mounted () {
            // console.log(this.moduleDetails)
        },

        data () {
            return {
                user_data: {},
                date_menu: false,
                dateMenu: false,
                triggerFeedback: false,
                expediteDialog: false,
                holdArgs: {},
                stepArgs: {},
                statusArgs: {},
                expediteArgs: {},
                moduleKey: '',
                moduleId: '',
                projectId: '',
                updateProject: {},
                debounceTimeout: null,
                toDollars: toDollars,
            }
        },
        
        methods: {
            annualizeDefaultChanged( value ) {
                // CONFIRM BEFORE TURNING IT OFF; REVERT THE SWITCH IF THEY CANCEL
                if ( !value && !confirm(`Are you sure you want to turn off Annualize Default?\n\nNew ${this.moduleDetails.module_name} projects will no longer start as annual projects.`) ) {
                    // WAIT A TICK SO THE SWITCH REGISTERS THE CHANGE BACK (SAME-TICK REVERT IS IGNORED BY VUETIFY)
                    this.$nextTick(() => {
                        this.moduleDetails.annualize_default = true
                    })
                    return
                }

                this.debounceDelay({module_id: this.moduleDetails.module_id, annualize_default: value})
            },

            debounceDelay( module_data ) {
                clearTimeout(this.debounceTimeout);
                this.debounceTimeout = setTimeout(() => {
                    this.$emit('saveModuleData', module_data)
                }, 500);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .bg_pewter {
        background-color: #E9EAEC !important;
    }
    .menu_bg_primary {
        background-color: #eef7f8 !important;
    }
    .icon-size {
        width: 3rem;
    }
    .icon-size-small {
        width: 2.25rem;
    }
    .icon-size-header {
        width: 3rem;
    }
    .icon-center {
        margin: 0 auto;
    }
    .refresh_response {
        font-size: .8rem;
    }
    .click_indicator {
		width: 50px; 
		height: 3px; 
		border-top: 1px dotted rgba(0,0,0,.3);
		border-bottom: 1px dotted rgba(0,0,0,.3);
	}
    .clear_ecd {
        margin-top: 2px
    }
    .user_link {
        text-decoration: none;
    }
    .user_link:hover {
        text-decoration: underline;
    }
    .multi-service-tag {
        border-radius: 5px;
        background: #e09551; 
        font-size: 11px;
        font-weight: bold;
        color: white;
        text-align: center;
        width: 146px;
        height: 24px;
    }
    /* BOX SIZES TO THE TOGGLE ROW; THE FIELDS FILL IT WITHOUT WIDENING IT */
    .expedite_block {
        width: fit-content;
    }
    .expedite_field {
        width: 0;
        min-width: 100%;
    }

    .bordered_block { 
        /* rounded corners, with a background color and padding to separate it from other sections */
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        border: 1px solid #ccc;
        background-color: #fcfcfc;
    }
</style>


// WEBPACK FOOTER //
// src/components/ModuleData.vue